// removed by extract-text-webpack-plugin
module.exports = {"failure":"c-Failure__failure"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Failure/Failure.scss
// module id = 557
// module chunks = 0